/**
 * Did the user arrive in Fitting from Core's Capacitor app (via
 * SFSafariViewController popover)?
 *
 * Set by Fitting's `lib/supabase.ts` IIFE when it sees `?from=core` on
 * the initial URL — Core's `goToFitting` writes that param when it
 * launches the cross-WebView nav. Read by golfer-nav surfaces (bottom
 * nav, sidebar) to suppress the "My Bag" affordance, which would
 * otherwise load Core *inside* the popover on top of the parent Core
 * app underneath (iOS provides no JS API to dismiss
 * SFSafariViewController, so the only sanctioned exit is the system
 * "Done" button at the top of the popover).
 *
 * Returns true on web only when the page was actually opened from
 * Core via the cross-WebView path — direct visits to golfauth.com/golfer
 * are unaffected.
 */
export function arrivedFromCore(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return sessionStorage.getItem('golfauth_arrived_via') === 'core';
  } catch {
    // sessionStorage can throw in iOS Safari private mode.
    return false;
  }
}
